import { render, staticRenderFns } from "./ChatToolbar.vue?vue&type=template&id=20673906&scoped=true&"
import script from "./ChatToolbar.vue?vue&type=script&lang=js&"
export * from "./ChatToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20673906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20673906')) {
      api.createRecord('20673906', component.options)
    } else {
      api.reload('20673906', component.options)
    }
    module.hot.accept("./ChatToolbar.vue?vue&type=template&id=20673906&scoped=true&", function () {
      api.rerender('20673906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/ChatToolbar.vue"
export default component.exports